import { User } from "oidc-client"
import { usePermissionsOptimized } from "ra-core"
import { useMemo } from "react"
import { Permissions_new } from "~/constants"
import { userManager, CastedUserManager, AccessTokenClaims } from "./odUserManager"


// perfer useOdPermissions() instead of usePermissions, usePermissionsOptimized:
//   permits are retrieved from access_token which is stored in localstorage; 
//   the retrieving process can be synchronous instead of asynchronous, 
//   thus no need to handle state in between when permits are not determined, 
//   (it always will be determined as long as user is logged in)
export const useOdPermissions = () => {
  const { permissions } = usePermissionsOptimized()
  return useMemo(() => {
    const ps = new Set<Permissions_new>((permissions ?? ((()=>{
      // when usePermissionsOptimized() initially load, it will return undefined
      // then we have to read permissions directly from the access_token stored in localStorage
      const um = userManager as CastedUserManager
      const user = User.fromStorageString(
        window.localStorage.getItem('oidc.'+um._userStoreKey) ?? '{}'
      )
      if (!user.access_token) { return [] }
      const jwtAt = um._joseUtil.parseJwt<AccessTokenClaims>(user.access_token)
      return (!jwtAt || !jwtAt.payload.permissions) ? []
      : jwtAt.payload.permissions instanceof Array  ? jwtAt.payload.permissions
      : [jwtAt.payload.permissions]
    })())))
    return ps
  }, [permissions])
}


